export const statusChoices = [
    { id: 'pending', name: '待处理' },
    { id: 'confirmed', name: '已确认' },
    { id: 'in_progress', name: '进行中' },
    { id: 'completed', name: '已完成' },
    { id: 'cancelled', name: '已取消' },
];

export const statusToChinese = (status: string) => {
    switch (status) {
        case 'pending':
            return '待处理';
        case 'confirmed':
            return '已确认';
        case 'in_progress':
            return '进行中';
        case 'completed':
            return '已完成';
        case 'cancelled':
            return '已取消';
        default:
            return status;
    }
};